import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, createCachedGetAction, createGetSuccessAction } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import { LoyaltyEarnPoints, LoyaltyMemberLevel } from "./loyalty-content.model";

export const ACTION_PREFIX = "[Loyalty Content]";
export const LOYALTY_CONTENT_ACTION_TYPE = {
	getMemberLevels: `${ACTION_PREFIX} Get Member Levels`,
	getMemberLevelsSuccess: `${ACTION_PREFIX} Get Member Levels Success`,
	getMemberLevelsFail: `${ACTION_PREFIX} Get Member Levels Fail`,
	getEarnPoints: `${ACTION_PREFIX} Get Earn Points`,
	getEarnPointsSuccess: `${ACTION_PREFIX} Get Earn Points Success`,
	getEarnPointsFail: `${ACTION_PREFIX} Get Earn Points Fail`,
};

@Injectable({
	providedIn: "root",
})
/**
 * @deprecated [fabric-deprecated] - Use event bus retrieve with AccountAppValue instead
 */
export class LoyaltyContentAction {
	/**
	 * @deprecated [fabric-deprecated] - Use event bus retrieve with AccountAppValue.GetLoyaltyContentMemberLevels instead
	 */
	getMemberLevels(): Action {
		return createCachedGetAction({
			type: LOYALTY_CONTENT_ACTION_TYPE.getMemberLevels,
		});
	}
	/**
	 * @deprecated [fabric-deprecated] - Use event bus retrieve with AccountAppValue.GetLoyaltyContentMemberLevels instead
	 */
	getMemberLevelsSuccess(payload: LoyaltyMemberLevel[]): ActionWithPayload {
		return createGetSuccessAction({
			type: LOYALTY_CONTENT_ACTION_TYPE.getMemberLevelsSuccess,
			payload,
		});
	}
	/**
	 * @deprecated [fabric-deprecated] - Use event bus retrieve with AccountAppValue.GetLoyaltyContentMemberLevels instead
	 */
	getMemberLevelsFail(payload: AppError): ActionWithPayload {
		return {
			type: LOYALTY_CONTENT_ACTION_TYPE.getMemberLevelsFail,
			payload,
		};
	}
	/**
	 * @deprecated [fabric-deprecated] - Use event bus retrieve with AccountAppValue.GetLoyaltyContentEarnPoints instead
	 */
	getEarnPoints(): Action {
		return createCachedGetAction({
			type: LOYALTY_CONTENT_ACTION_TYPE.getEarnPoints,
		});
	}
	/**
	 * @deprecated [fabric-deprecated] - Use event bus retrieve with AccountAppValue.GetLoyaltyContentEarnPoints instead
	 */
	getEarnPointsSuccess(payload: LoyaltyEarnPoints): ActionWithPayload {
		return createGetSuccessAction({
			type: LOYALTY_CONTENT_ACTION_TYPE.getEarnPointsSuccess,
			payload,
		});
	}
	/**
	 * @deprecated [fabric-deprecated] - Use event bus retrieve with AccountAppValue.GetLoyaltyContentEarnPoints instead
	 */
	getEarnPointsFail(payload: AppError): ActionWithPayload {
		return {
			type: LOYALTY_CONTENT_ACTION_TYPE.getEarnPointsFail,
			payload,
		};
	}
}
